import React, {Component} from 'react';
import {Button} from 'reactstrap';
import './Finish-paper.scss';
import * as constants from "../../../../const/constants";
import ImgUndergraduation from '../../../../assets/img/common/undraw_Graduation_ktn0.png';
import {lang, language} from "../../../../const/language";
import * as paperServicess from "../../../../services/papers";
import * as commonFunc from "../../../../utils/commonFunc";
import * as actionSpinnerCreator from "../../../../store/domain/spinner/action";
import * as actionClassCreator from "../../../../store/domain/classes/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";

class App extends Component {
    state = {
        mobileView: 0,
        mark: '',
        questions: ''
    };

    componentDidMount() {
        this.screeSizeChecking()
        this.setState({
            mark: localStorage.getItem("Marks"),
            questions: localStorage.getItem("Quiz"),
        })
    }

    screeSizeChecking = () => {
        if (window.innerWidth <= 991) {
            this.setState({
                mobileView: 1
            });
        } else {
            this.setState({
                mobileView: 0
            });
        }
    }

    completeExam = () => {
        localStorage.setItem("presentage", "");
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_EXAM_ROUTE}`);
    }

    shareCertificate = async (type) => {
        this.props.spinnerHandler(true);
        await paperServicess.getCertificate(this.props.userObj.id, type)
            .then(response => {
                this.props.spinnerHandler(false);
                if (response.success) {
                    const element = document.createElement('a')
                    element.setAttribute('href', response.body.certificateBase64)
                    element.setAttribute('download', 'student_certificate.pdf')
                    document.body.appendChild(element)
                    element.click()
                } else {
                    commonFunc.notifyMessage(response.message, response.status);
                }
            })
    }

    render() {
        return (
            <div className={"finish-paper-main"}>
                {
                    this.state.mobileView == 1 ?
                        <div className={"close-icon"}>
                            <p><i class="icofont-close" onClick={this.completeExam}></i></p>
                        </div>
                        :
                        <div className={"close-icon-web"}>
                        </div>
                }

                <div className={"common-wrapper"}>
                    <p className={"first-line"}> You score:</p>
                    <p className={"score-number"}>{this.state.mark}</p>
                    <p>out of {this.state.questions}</p>
                    {
                        this.state.mobileView === 1 ?
                            <img src={ImgUndergraduation} alt="img" style={{width: '45%'}}/>
                            :
                            null
                    }
                    {
                        this.state.mobileView === 1 ?
                            <div className="d-flex flex-column align-items-center">
                                <Button className={"Continue-btn"} onClick={this.completeExam}>
                                    Continue
                                </Button>
                                <Button className={"Continue-btn bold-text"}
                                    // style={{width: '25%'}}
                                        onClick={() => this.shareCertificate("DOWNLOAD")}>
                                    { language[lang].collectCertificate}
                                </Button>
                            </div>
                            :<div className="d-flex flex-column align-items-center">
                                <Button className={"Continue-btn-web mb-1"} onClick={this.completeExam}>
                                    Continue
                                </Button>
                                <Button className={"Continue-btn-web bold-text"}
                                        style={{width: '25%'}}
                                        onClick={() => this.shareCertificate("DOWNLOAD")}>
                                    { language[lang].collectCertificate}
                                </Button>
                            </div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    purchaseClasses: state.classes.purchaseClasses,
    userObj: state.student.userObj,
    isSpinner: state.spinner.isSpinner,
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    fetchAllPurchasedClass: data => dispatch(actionClassCreator.fetchAllPurchasedClass(data)),
    selectMyClassPagination: data => dispatch(actionClassCreator.selectMyClassPagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));


